import { AppStoreButton } from '../../components/wallet/AppStoreButton'

type Props = { active?: boolean }

export function Scan(_props: Props) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-6 py-6">
      <img
        src="/nanza-logo-full-white.svg"
        alt="Nanza"
        className="h-[34px] w-auto"
      />
      <div className="aspect-square w-full max-w-[66vmin] rounded-[32px] bg-white p-5 shadow-2xl">
        <img
          src="/MOBILE-APP-LINKS%205-16-2026.svg"
          alt="Scan to download Nanza"
          className="h-full w-full"
          draggable={false}
        />
      </div>
      <AppStoreButton />
    </div>
  )
}
